// DEPENDENCIES
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import { useParams } from 'react-router';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'flatpickr/dist/themes/material_green.css';
import * as _ from 'lodash';
// COMPONENTS
import { Form, Modal, Button, Alert } from 'react-bootstrap';
import Select from 'react-select';
import { ModalProgressBar } from '../../../_metronic/_partials/controls';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import DatePicker from 'react-datepicker';
import MaskedInput from 'react-maskedinput';
import MUIDataTable from 'mui-datatables';
// CUSTOM COMPONENTS
import * as alert from '../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import UserCredentialValidator from '../../../helpers/validators/UserCredentialValidator';
import { getInputClasses, convertJsonToFormData, setToOptionModel, formatToUSDate } from '../../../helpers/helper';
import * as credentialService from '../../../services/training/credentialService';
import * as userCredentialService from '../../../services/training/userCredentialService';
import * as userService from '../../../services/management/userService';
import * as trainingTypeService from '../../../services/companyData/trainingTypeService';
import * as trainingSubTypeService from '../../../services/companyData/trainingSubTypeService';
import constants from '../../../constants/constants';

const moment = require('moment');
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const UserCredentialDetailPage = (props) => {
  const { auth, history, showConfirmModal, hideConfirmModal } = props;
  const { credentialId } = useParams();
  var initialValues = {
    id: credentialId,
    userId: 0,
    trainingTypeId: null,
    trainingSubTypeId: null,
    credentialId: 0,
    effectiveDate: new moment().format('MM/DD/yyyy'),
    expiryDate: '',
    comments: '',
    imageUrl: '',
    siteCode: '',
    uploadedFile: null,
    archivedDateTime: '',
    isArchived: false,
  };
  const { showAlert } = props;
  const [loading, setloading] = useState(false);
  const [savedCredentialValue, setSavedCredentialValue] = useState(initialValues);
  const [userList, setUserList] = useState([]);
  const [credentialList, setCredentialList] = useState([]);
  const [trainingTypeList, setTrainingTypeList] = useState([]);
  const [trainingSubTypeList, setTrainingSubTypeList] = useState([]);
  const intervalRef = useRef();
  const frequencyRef = useRef();
  const [isDocumentSubmitting, setIsDocumentSubmitting] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedCredential, setSelectedCredential] = useState(null);
  const [selectedTrainingType, setSelectedTrainingType] = useState(null);
  const [selectedTrainingSubType, setSelectedTrainingSubType] = useState(null);
  const [uploadedAttachments, setUploadedAttachments] = useState([]);
  const [renameModalVisible, setRenameModalVisible] = useState(false);
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [duplicateCredentialId, setDuplicateCredentialId] = useState(0);
  const [archivedType, setArchivedType] = useState('');
  const [archivedSubType, setArchivedSubType] = useState('');
  const [archivedCredential, setArchivedCredential] = useState('');
  const [attachmentToRename, setAttachmentToRename] = useState({
    name: '',
    id: 0,
  });

  useEffect(() => {
    loadSelectList();
  }, []);

  const loadSelectList = async () => {
    var trainingTypes = await fetchTrainingType();

    var users = await userService.getAllUsers(!auth.isAdmin).then((res) => {
      setUserList(res);

      if (history.location.state) {
        let userIdFromHistory = history.location.state.userId;
        setSelectedUser(res.find((x) => x.id == userIdFromHistory));
        setSelectedUserState(res, userIdFromHistory);

        setSavedCredentialValue({ ...initialValues, userId: userIdFromHistory });
      }
      return res;
    });

    if (initialValues.id > 0) {
      await setSavedFormValues(users, trainingTypes);
    }
  };

  const fetchTrainingType = async () => {
    return trainingTypeService
      .getTrainingTypes(false)
      .then((res) => {
        let options = res.map((x) => setToOptionModel(x.name, x.id));
        setTrainingTypeList(options);

        return options;
      })
      .catch((ex) => showAlert({ message: ex.message, variant: 'error' }));
  };

  const fetchTrainingSubType = async (trainingTypeId) => {
    return trainingSubTypeService.getTrainingSubTypes(trainingTypeId, false).then((res) => {
      let options = res.map((x) => setToOptionModel(x.name, x.id));
      options.push(setToOptionModel('No SubType', 0));
      setTrainingSubTypeList(options);

      return options;
    });
  };

  const fetchCredential = (typeId, subTypeId) => {
    return credentialService.getCredentialsByTypeAndSubType(typeId, subTypeId).then((res) => {
      var options = res.map((x) => setToOptionModel(x.name, x.id));
      setCredentialList(options);

      return options;
    });
  };

  const GetUploadedAttachments = () => {
    userCredentialService
      .getAttachments(initialValues.id)
      .then((res) => {
        setUploadedAttachments(res);
      })
      .catch((ex) => {
        showAlert({ message: 'Something went wrong trying to fetch the attahcments. Please try again', variant: 'warning' });
      });
  };

  const setSavedFormValues = async (users, trainingTypes) => {
    GetUploadedAttachments();
    await userCredentialService.getUserCredentialById(initialValues.id).then(async (res) => {
      setSavedCredentialValue(res);
      setSelectedUserState(users, res.userId);
      fetchIntervalAndFrequency(res.credentialId);
      if (res.isArchived) {
        fetchTypeSubTypeAndCredentialForArchived(res);
      } else {
        var trainingSubTypes = await fetchTrainingSubType(res.trainingTypeId);
        var crendentials = await fetchCredential(res.trainingTypeId, res.trainingSubTypeId ? res.trainingSubTypeId : 0);

        var trainingTypeSelected = trainingTypes.find((x) => x.value == res.trainingTypeId);
        var trainingSubTypeSelected = trainingSubTypes.find((x) => x.value == (res.trainingSubTypeId ? res.trainingSubTypeId : 0));
        var credentialSelected = crendentials.find((x) => x.value == res.credentialId);

        if (trainingTypeSelected) {
          setSelectedTrainingType(setToOptionModel(trainingTypeSelected.label, trainingTypeSelected.value));
        }
        if (trainingSubTypeSelected) {
          setSelectedTrainingSubType(setToOptionModel(trainingSubTypeSelected.label, trainingSubTypeSelected.value));
        }
        if (credentialSelected) {
          setSelectedCredential(setToOptionModel(credentialSelected.label, credentialSelected.value));
        }
      }
    });
  };

  const fetchTypeSubTypeAndCredentialForArchived = (userCredential) => {
    trainingTypeService.getTrainingTypeById(userCredential.trainingTypeId).then((res) => {
      setArchivedType(res.name);
    });

    if (userCredential.trainingSubTypeId) {
      trainingSubTypeService.getTrainingSubTypeById(userCredential.trainingSubTypeId).then((res) => {
        setArchivedSubType(res.name);
      });
    }

    credentialService.getCredentialById(userCredential.credentialId).then((res) => {
      setArchivedCredential(res.name);
    });
  };

  const setSelectedUserState = (userList, userId) => {
    var userSelected = userList.find((x) => x.id == userId);
    setSelectedUser(setToOptionModel(userSelected.fullName, userId));
  };

  const createUserCredentialHandler = (values, setStatus, setSubmitting) => {
    setSubmitting(true);
    setloading(true);
    userCredentialService
      .saveUserCredential(convertJsonToFormData({ ...values, uploadedFiles: uploadedFile ? uploadedFile.map((x) => x.file) : null }))
      .then((res) => {
        props.history.push('/training/user-credentials');
        showAlert({ message: res.message, variant: 'success' });
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
        setSubmitting(false);
        setloading(false);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: savedCredentialValue,
    validationSchema: UserCredentialValidator,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      createUserCredentialHandler(values, setStatus, setSubmitting);
    },
  });

  const fetchIntervalAndFrequency = (selectedValue) => {
    credentialService.getCredentialById(selectedValue).then((res) => {
      intervalRef.current.value = res.intervalType.name;
      frequencyRef.current.value = res.frequency;
    });
  };

  const handleTrainingTypeChange = (val) => {
    setSelectedTrainingSubType(null);
    setSelectedCredential(null);
    setSelectedTrainingType(val);
    formik.setFieldValue('trainingTypeId', val.value);
    formik.setFieldValue('trainingSubTypeId', '');
    formik.setFieldValue('credentialId', '');
    fetchTrainingSubType(val.value);
  };

  const handleTrainingSubTypeChange = (val) => {
    setSelectedCredential(null);
    setSelectedTrainingSubType(val);
    formik.setFieldValue('trainingSubTypeId', val.value);
    formik.setFieldValue('credentialId', '');
    fetchCredential(selectedTrainingType.value, val.value);
  };

  const deleteAttachment = (attachmentId) => {
    userCredentialService
      .deleteAttachment(attachmentId)
      .then((res) => {
        GetUploadedAttachments();
        showAlert({ variant: 'success', message: res.message });
      })
      .catch((ex) => {
        showAlert({ variant: 'error', message: ex.message });
      })
      .finally(() => {
        hideConfirmModal();
      });
  };

  const openModalToRename = (file) => {
    setAttachmentToRename({
      name: file.fileName,
      id: file.id,
    });
    setRenameModalVisible(true);
  };

  const renameFileAndCloseModal = () => {
    userCredentialService
      .renameAttachment(attachmentToRename.id, attachmentToRename.name)
      .then((res) => {
        GetUploadedAttachments();
        showAlert({ message: res.message, variant: 'success' });
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      })
      .finally(() => setRenameModalVisible(false));
  };

  const uploadFilesAndCloseModal = () => {
    setIsDocumentSubmitting(true);
    userCredentialService
      .saveAttachment(convertJsonToFormData({ id: savedCredentialValue.id, uploadedFiles: uploadedFile.map((x) => x.file) }))
      .then((res) => {
        GetUploadedAttachments();
        showAlert({ message: res.message, variant: 'success' });
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      })
      .finally(() => {
        setUploadModalVisible(false);
        setIsDocumentSubmitting(false);
      });
  };

  const checkDuplicateCredential = (credential, user) => {
    if (credential != null && user != null) {
      userCredentialService
        .checkDuplicate(user.value, credential.value, savedCredentialValue.id === 0 ? null : savedCredentialValue.id)
        .then((res) => {
          setDuplicateCredentialId(res);
        });
    }
  };

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        width: 1,
        print: false,
        download: false,
        setCellProps: () => ({
          'data-aes-field': 'actions',
          'data-aes-label': 'Actions',
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className='aes-admin-listing-actions'>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={constants.API_URL + uploadedAttachments[dataIndex].filePath}
                className='btn btn-sm btn-primary font-weight-bold py-2 px-3 px-xxl-5'
              >
                View
              </a>{' '}
              <button
                type='button'
                onClick={() => openModalToRename(uploadedAttachments[dataIndex])}
                className='btn btn-sm btn-warning font-weight-bold py-2 px-3 px-xxl-5'
              >
                Rename
              </button>{' '}
              {!savedCredentialValue.isArchived && (
                <button
                  onClick={() =>
                    showConfirmModal({
                      title: 'Delete Project Type',
                      text: 'Are you sure you want to delete this attachment?',
                      rightBtnText: 'Confirm',
                      btnAction: () => deleteAttachment(uploadedAttachments[dataIndex].id),
                    })
                  }
                  type='button'
                  className='btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5'
                >
                  Delete
                </button>
              )}
            </div>
          );
        },
      },
    },
    {
      name: 'fileName',
      label: 'File Name',
      options: {
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'primary',
          'data-aes-label': 'File Name',
        }),
      },
    },
    {
      name: 'fileExtension',
      label: 'File Extension/Type',
      options: {
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'file-type',
          'data-aes-label': 'File Extension/Type',
        }),
      },
    },
    {
      name: 'uploadedDateTime',
      label: 'Uploaded Date',
      options: {
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'uploaded-date',
          'data-aes-label': 'Uploaded Date',
        }),
      },
    },
  ];

  return (
    <>
      <Modal centered size='lg' show={renameModalVisible} onHide={() => setRenameModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Rename Attachment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='form'>
            <div className='card-body'>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Name</label>
                <div className='col-lg-9 col-xl-9'>
                  <div className='input-group input-group-lg input-group-solid'>
                    <input
                      placeholder='Start typing...'
                      className={`form-control form-control-lg form-control-solid`}
                      name='name'
                      value={attachmentToRename.name}
                      onChange={(e) => setAttachmentToRename({ ...attachmentToRename, name: e.target.value })}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setRenameModalVisible(false)}>
            Close
          </Button>
          <button type='submit' className='btn btn-success mr-2' onClick={() => renameFileAndCloseModal()}>
            Save
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        size='lg'
        show={uploadModalVisible}
        onHide={() => setUploadModalVisible(false)}
        dialogClassName='aes-credential-upload-modal'
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Attachments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FilePond
            allowMultiple={true}
            labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
            onupdatefiles={setUploadedFile}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setUploadModalVisible(false)}>
            Close
          </Button>
          <button disabled={isDocumentSubmitting} type='submit' className='btn btn-primary mr-2' onClick={() => uploadFilesAndCloseModal()}>
            Upload
          </button>
        </Modal.Footer>
      </Modal>
      <form className='card card-custom card-stretch' onSubmit={formik.handleSubmit}>
        {loading && <ModalProgressBar />}
        <div className='card-header py-3'>
          <div className='card-title align-items-start flex-column'>
            <h3 className='card-label font-weight-bolder text-dark'>{savedCredentialValue.id == 0 ? 'Add' : 'Update'} User Credentials</h3>
            <span className='text-muted font-weight-bold fz-xs mt-1'>Please fill out the form below</span>
          </div>
          <div className='card-toolbar'>
            {!savedCredentialValue.isArchived && (
              <button
                type='submit'
                className={`btn btn-success mr-2`}
                disabled={formik.isSubmitting || (formik.touched && !formik.isValid)}
              >
                {savedCredentialValue.id == 0 ? 'Add' : 'Save'} Credential
                {formik.isSubmitting}
              </button>
            )}
            <a onClick={() => history.goBack()} className='btn btn-danger'>
              Cancel
            </a>
          </div>
        </div>
        <div className='form'>
          <div className='card-body'>
            <fieldset disabled={savedCredentialValue.isArchived}>
              {duplicateCredentialId > 0 && (
                <Alert variant='warning'>
                  Credential <strong>{selectedCredential.label}</strong> already exists for <b>{selectedUser.label}</b>.{' '}
                  <a
                    style={{ color: 'white', textDecoration: 'underline' }}
                    target='_blank'
                    href={`/training/user-credentials/edit-credential/${duplicateCredentialId}`}
                    rel='noreferrer'
                  >
                    Click here to view.
                  </a>
                </Alert>
              )}
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Employee</label>
                <div className='col-lg-9 col-xl-9'>
                  <Select
                    value={selectedUser}
                    options={userList.map((x) => setToOptionModel(x.fullName, x.id))}
                    onChange={(selectedOption) => {
                      setSelectedUser(selectedOption);
                      formik.setFieldValue('userId', selectedOption.value);
                      checkDuplicateCredential(selectedCredential, selectedOption);
                    }}
                    className={`${getInputClasses(formik, 'userId')}`}
                    name='userId'
                    placeholder='Select an Employee'
                  />
                  {formik.touched.userId && formik.errors.userId ? <div className='invalid-feedback'>{formik.errors.userId}</div> : null}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Credential Type</label>

                <div className='col-lg-9 col-xl-9'>
                  {savedCredentialValue.isArchived ? (
                    <input value={archivedType} className={`form-control form-control-lg form-control-solid`} />
                  ) : (
                    <>
                      <Select
                        value={selectedTrainingType}
                        options={trainingTypeList}
                        onChange={handleTrainingTypeChange}
                        className={`${getInputClasses(formik, 'trainingTypeId')}`}
                        name='trainingTypeId'
                        placeholder='Select Credential Type'
                      />
                      {formik.touched.trainingTypeId && formik.errors.trainingTypeId ? (
                        <div className='invalid-feedback'>{formik.errors.trainingTypeId}</div>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>
                  Credential Sub Type
                </label>
                <div className='col-lg-9 col-xl-9'>
                  {savedCredentialValue.isArchived ? (
                    <input value={archivedSubType} className={`form-control form-control-lg form-control-solid`} />
                  ) : (
                    <>
                      <Select
                        value={selectedTrainingSubType}
                        options={trainingSubTypeList}
                        onChange={handleTrainingSubTypeChange}
                        className={`${getInputClasses(formik, 'trainingSubTypeId')}`}
                        name='trainingSubTypeId'
                        placeholder='Select Credential Sub Type'
                      />

                      {formik.touched.trainingSubTypeId && formik.errors.trainingSubTypeId ? (
                        <div className='invalid-feedback'>{formik.errors.trainingSubTypeId}</div>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Credential</label>
                <div className='col-lg-9 col-xl-9'>
                  {savedCredentialValue.isArchived ? (
                    <input value={archivedCredential} className={`form-control form-control-lg form-control-solid`} />
                  ) : (
                    <>
                      <Select
                        value={selectedCredential}
                        options={credentialList}
                        onChange={(selectedOption) => {
                          setSelectedCredential(selectedOption);
                          formik.setFieldValue('credentialId', selectedOption.value);
                          if (selectedOption) {
                            fetchIntervalAndFrequency(selectedOption.value);
                          }
                          checkDuplicateCredential(selectedOption, selectedUser);
                        }}
                        className={`${getInputClasses(formik, 'credentialId')}`}
                        name='credentialId'
                        placeholder='Select Credential'
                      />

                      {formik.touched.credentialId && formik.errors.credentialId ? (
                        <div className='invalid-feedback'>{formik.errors.credentialId}</div>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Interval</label>
                <div className='col-lg-9 col-xl-9'>
                  <input
                    disabled
                    ref={intervalRef}
                    type='text'
                    placeholder='Select Credential to fetch Interval'
                    className={`form-control form-control-lg form-control-solid`}
                  />
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Frequency</label>
                <div className='col-lg-9 col-xl-9'>
                  <input
                    disabled
                    ref={frequencyRef}
                    type='text'
                    placeholder='Select Credential to fetch Frequency'
                    className={`form-control form-control-lg form-control-solid`}
                  />
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Effective Date</label>
                <div className='col-lg-9 col-xl-9'>
                  <DatePicker
                    value={formik.getFieldProps('effectiveDate').value ? formatToUSDate(formik.getFieldProps('effectiveDate').value) : null}
                    dateFormat='MM/dd/yyyy'
                    selected={formik.getFieldProps('effectiveDate').value ? new Date(formik.getFieldProps('effectiveDate').value) : null}
                    customInput={
                      <MaskedInput
                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'effectiveDate')}`}
                        mask='11/11/1111'
                        placeholder='MM/DD/YYYY'
                      />
                    }
                    onChange={(date) => {
                      formik.setFieldValue('effectiveDate', formatToUSDate(date));
                    }}
                    onBlur={(e) => {
                      if (e.target.value.includes('_') || e.target.value === '') {
                        formik.setFieldValue('effectiveDate', '');
                      }

                      formik.setFieldTouched('effectiveDate');
                    }}
                  />
                  {formik.touched.effectiveDate && formik.errors.effectiveDate ? (
                    <div className='invalid-feedback'>{formik.errors.effectiveDate}</div>
                  ) : null}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Expiry Date</label>
                <div className='col-lg-9 col-xl-9'>
                  <DatePicker
                    value={formik.getFieldProps('expiryDate').value ? formatToUSDate(formik.getFieldProps('expiryDate').value) : null}
                    dateFormat='MM/dd/yyyy'
                    selected={formik.getFieldProps('expiryDate').value ? new Date(formik.getFieldProps('expiryDate').value) : null}
                    customInput={
                      <MaskedInput
                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'expiryDate')}`}
                        mask='11/11/1111'
                        placeholder='MM/DD/YYYY'
                      />
                    }
                    onChange={(date) => {
                      formik.setFieldValue('expiryDate', formatToUSDate(date));
                    }}
                    onBlur={(e) => {
                      if (e.target.value.includes('_') || e.target.value === '') {
                        formik.setFieldValue('expiryDate', '');
                      }

                      formik.setFieldTouched('expiryDate');
                    }}
                  />
                  {formik.touched.expiryDate && formik.errors.expiryDate ? (
                    <div className='invalid-feedback'>{formik.errors.expiryDate}</div>
                  ) : null}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Site Code</label>
                <div className='col-lg-9 col-xl-9'>
                  <input
                    type='text'
                    placeholder='Enter Site Code'
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'siteCode')}`}
                    name='siteCode'
                    {...formik.getFieldProps('siteCode')}
                  />
                  {formik.touched.siteCode && formik.errors.siteCode ? (
                    <div className='invalid-feedback'>{formik.errors.siteCode}</div>
                  ) : null}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Comments</label>
                <div className='col-lg-9 col-xl-9'>
                  <Form.Control
                    as='textarea'
                    rows='5'
                    placeholder='Start typing...'
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'comments')}`}
                    name='comments'
                    {...formik.getFieldProps('comments')}
                  />

                  {formik.touched.comments && formik.errors.comments ? (
                    <div className='invalid-feedback'>{formik.errors.comments}</div>
                  ) : null}
                </div>
              </div>
            </fieldset>
            {savedCredentialValue.id > 0 ? (
              <div className='col-xl-12 col-lg-12 aes-admin-listing-page aes-admin-listing-page--credential-uploaded-files px-0'>
                <div className='aes-admin-listing px-0'>
                  <div className='flex justify-content-between align-items-center flex-wrap mt-20 mb-10'>
                    <h3 className='card-label font-size-h3 font-weight-bolder text-dark'>Uploaded Files</h3>
                    {!savedCredentialValue.isArchived && (
                      <button
                        type='button'
                        onClick={() => setUploadModalVisible(true)}
                        className='btn btn-info mr-2 aes-credential-uploaded-files__add'
                        style={{ float: 'right' }}
                      >
                        Add File
                      </button>
                    )}
                  </div>
                  <MUIDataTable
                    className='aes-admin-listing-surface'
                    data={uploadedAttachments}
                    columns={columns}
                    options={{
                      responsive: 'standard',
                      rowsPerPage: 25,
                      rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                      selectableRows: 'none',
                      downloadOptions: {
                        filename: 'User_Credential_Uploads.csv',
                        filterOptions: {
                          useDisplayedColumnsOnly: true,
                          useDisplayedRowsOnly: true,
                        },
                      },
                      setTableProps: () => ({
                        className: 'aes-admin-listing-table',
                      }),
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Uploads</label>
                <div className='col-lg-9 col-xl-9'>
                  <FilePond
                    allowMultiple={true}
                    labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                    onupdatefiles={setUploadedFile}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(UserCredentialDetailPage);
